import { SET_BROADCAST } from '../actions/Types';
import { startSurvey } from '@intercom/messenger-js-sdk';
import { getEnvVar } from '@studio/environment/getEnvVar';
import { shouldTriggerSurvey } from 'utils/stream';

function startSurveyOnStreamEnd(store) {
  const { getState } = store;
  return next => async action => {
    if (action.type !== SET_BROADCAST) {
      return next(action);
    }

    const {
      broadcast: { endpoints: previousEndpoints = [] }
    } = getState();
    const nextEndpoints = action.payload.endpoints;

    if (shouldTriggerSurvey(previousEndpoints, nextEndpoints)) {
      startSurvey(getEnvVar('REACT_APP_INTERCOM_STOP_STREAM_SURVEY_ID'));
    }

    return next(action);
  };
}

export default startSurveyOnStreamEnd;
